<h1 class="mb-4">Szczegóły komunikatu</h1>

<p-tabs value="0" lazy [class]="'customTab'">
  <p-tablist>
    <p-tab value="0">Dane podstawowe</p-tab>
    <p-tab value="1">Historia zdarzeń</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (announcement()) {
        <app-admin-panel-announcement-details
          [announcement]="announcement()!"
        ></app-admin-panel-announcement-details>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-admin-panel-announcement-history></app-admin-panel-announcement-history>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
